import type { FaireProductEntity } from "../../entity_types/product";

export const p_43rwanydq9: FaireProductEntity = {
  token: "p_43rwanydq9",
  type: "product",
  name: "Minnesota Lake | Wood Magnet",
  brandName: "Fuzzy Loon Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/a29ce5b75791248f9067edf7f2a769149c91dea8a9ec33f3a385ce46756edf25.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ef984654237c8ed908f4a7de51c97c08852b0933f224c36ba7b8b208e6ee3ce8.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
